var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPentagon = function SvgPentagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.996.582a2 2 0 0 1 2.008 0l1.591.923 1.595.917a2 2 0 0 1 1.004 1.738L11.19 6l.004 1.84a2 2 0 0 1-1.004 1.738l-1.595.917-1.591.923a2 2 0 0 1-2.008 0l-1.591-.923-1.595-.917A2 2 0 0 1 .806 7.84L.81 6 .806 4.16A2 2 0 0 1 1.81 2.422l1.595-.917z"
  })));
};
export default SvgPentagon;